import { formatBigNumber } from "@/src/utils";

/**
 * 24 小时涨跌幅格式化的配置项。
 */
interface FormatChangeOptions {
  /**
   * 是否在 0 变化时显示为 "--"
   * - true：展示 "--"，常用于 tooltip，表达「无明显变化」
   * - false：展示 "0%"，常用于卡片正文
   */
  zeroAsDash?: boolean;
}

/**
 * 通用 24h 涨跌幅格式化函数。
 *
 * @description
 * - 输入为「百分比小数」：例如 0.1404 表示 0.14%
 * - 输出为带符号和 % 的字符串：如 "+0.14%"、"-1.23%"、"0%" 或 "--"
 *
 * 约定：
 * - 不在函数内部进行 *100 操作，调用方负责保证入参含义一致
 */
export const formatChangePercent = (
  value: number | null | undefined,
  options?: FormatChangeOptions,
): string => {
  if (value == null || Number.isNaN(value)) {
    return "--";
  }

  const isFlat = value === 0;
  const isUp = value > 0;
  const absPercent = Math.abs(value);

  const zeroAsDash = options?.zeroAsDash ?? false;

  if (isFlat) {
    return zeroAsDash ? "--" : "0%";
  }

  const percentageText = `${formatBigNumber(absPercent, {
    needFormat: true,
    trimZeros: true,
    precision: 2,
  })}%`;

  const prefix = isUp ? "+" : "-";
  return `${prefix}${percentageText}`;
};
